// TODO: remove with https://github.com/combinaut/sparkle/issues/32203 once admin JS imports sp apps directly.
import { spSelectTag } from "#/admin/legacy/sp-select/index.js";

/** Returns a new searchable snippet sp-select. */
export function createSnippetSelect() {
  const markup = spSelectTag("", {
    searchable: true,
    placeholder: globalThis.Sparkle.t("admin.components.messages.choose_snippet"),
  });

  return document.createRange().createContextualFragment(markup).firstElementChild;
}

/** Returns the snippet whose value matches `value` as a string, or undefined. */
export function snippetChoice(snippets, value) {
  return snippets.find((row) => String(row.value) === String(value));
}

/** Returns the snippet's input params, or null when it takes none. */
export function snippetParams(choice) {
  return Object.keys(choice.input_params || {}).length ? choice.input_params : null;
}
